import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { deletePickingActions } from "store/ducks/pickings";

export function* deletePickingRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.delete,
      `/picking/${id}`
    );

    const { data } = responseBody;
    yield put(deletePickingActions.success(data));
    notify("success", "Carga deletada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(deletePickingActions.failure(errorMessage));
  }
}
